export const PGCLASS = {
  /*TABATA: "Tabata",
  PLAYFIT: "PlayFIT",
  PLAYSTR: "PlayStrength",
  FUNCMM: "Functional Movement",
  METCON: "MetCon",
  TRX: "TRX Total Body",
  YOGAST: "Strech Yoga",
  YOGAFL: "Flow Yoga",
  BUTTBLASTER: "Butt Blaster",
  FOAMROLL: "FMR FoamRoll",
  SENIOR: "Senior 50+",
  ZUMBA: "Zumba",
  BOXING: "Boxing",
  RUNBETTER: "Run Better",
  LIMITBREAK: "Limit Break",*/
  LEG: "Leg",
  PUSH: "Push",
  PULL: "Pull",
  ABS: "ABS & Core",
  BOXING: "Basic Boxing",
  WARMUP: "Warm Up",
  STRETCH: "Stretch",
  INJURY: "Injury Consult",
  HIIT: "HIIT",
};

//======= Copy from rooms table
export const PGROOM = {
  1: "Functional Zone",
  2: "Studio 1",
  3: "Studio 2",
};

//======= Copy from coaches table
export const PGCOACH = {
  1: "TBA",
  2: "Chor",
  3: "Fluke",
  4: "Arm",
  5: "Kru Aom",
  6: "Kru Nice",
  7: "Kru Nim",
  8: "Kru Neung",
};

export function isAuthLv2() {
  //return false;
  if (
    localStorage.getItem("user_role") == "ADMIN" ||
    localStorage.getItem("user_role") == "MANAGER" ||
    localStorage.getItem("user_role") == "ACCOUNTANT"
  ) {
    return true;
  }
  return false;
}
export function isAuthLv1() {
  if (
    localStorage.getItem("user_role") == "FRONT" ||
    localStorage.getItem("user_role") == "ADMIN" ||
    localStorage.getItem("user_role") == "MANAGER" ||
    localStorage.getItem("user_role") == "ACCOUNTANT"
  ) {
    return true;
  }
  return false;
}
